import Burst from './background-burst.svg';
import ContinueButton from './button-continue.svg';
import BrownPanel from './brown-panel.svg';
import GreenPanel from './green-panel.svg';

export default {
  Burst,
  BrownPanel,
  GreenPanel,
  ContinueButton,
};
